import { render, staticRenderFns } from "./MoneyCell.vue?vue&type=template&id=5dc4e070&scoped=true&"
import script from "./MoneyCell.vue?vue&type=script&lang=ts&setup=true&"
export * from "./MoneyCell.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./MoneyCell.vue?vue&type=style&index=0&id=5dc4e070&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc4e070",
  null
  
)

export default component.exports